import { Languages } from '../LanguageContext';

export const translations = {
  [Languages.ENGLISH]: {
    login_title: 'Psifas Project',
    login_subtitle: 'Personal area Login',
    invalid_phone_number_or_email_error_message: 'Please enter a valid phone number/email',
    login_description:
      'Enter the method you used when volunteering for Psifas to get a verification code',
    login_email_phone_placeholder: 'Mobile or Email address',
    login_get_code_button_text: 'Get verification code',
    footer_paragraph:
      'For any technical issue with opening the link or logging into the questionnaire, you can contact the following number:',
    exit_text: 'Home Page',
    general_sever_error: 'General error. Please try again later.',
    unauthorized_sf_error:
      'Some of the information you entered is invalid. Please check the information you entered again.',
    to_status_page_text: 'Login',
    check_input_modal_text:
      'Due to multiple attempts, your account has been temporarily blocked. Please try again later or contact the author by email',
    modal_exit_text: 'Back to Home Page',
    verification_description: 'A code wast sent to ',
    enter_code_placeholder: 'Enter Verification code',
    code_not_received: "I didn't receive the code. ",
    send_code_again: 'Send again',
    wait_for_code: 'The code is on its way...',
    invalid_code_message: 'Invalid code',
    form_does_not_exist_error:
      'The form has been filled and submitted; it cannot be accessed again.',
    accessibility_statement_subtitle: 'Terms of Use',
    accessibility_text_1: 'Accessibility Statement Update Date: 29.05.2024',
    accessibility_subheader_1: 'How to switch to accessible mode?',
    accessibility_subheader_2: 'Corrections and adjustments made to the site:',
    accessibility_subheader_3: 'Accessibility contact:',
    accessibility_subheader_4: 'Accessibility provider:',
    accessibility_paragraph_1: `Psifas is responsible for establishing and operating the site: https://psifas.org.il.
We see great importance in providing equal service to all citizens and improving the service provided to citizens with disabilities.
We invest significant resources in making our site and digital assets accessible to make the company's services more available to people with disabilities.`,
    accessibility_paragraph_2:
      "The site's accessibility is carried out in accordance with the Israeli accessibility standard 5568 to level AA.",
    accessibility_paragraph_3: `An accessibility icon is placed on the site (usually on the sides of the site). Clicking on the icon allows opening of the accessibility menu. After selecting the appropriate function in the menu, wait for the page to load and for the desired change in display (if necessary).
If you want to cancel the action, click on the function in the menu a second time. In any case, you can reset accessibility settings.
The site provides a semantic structure for assistive technologies and support for the conventional usage pattern for keyboard operation using arrow keys, Enter and Esc to exit menus and windows.`,
    accessibility_paragraph_4: `The site has been tested with an NVDA screen reader and is adapted for browsing in common browsers.
The navigation tools on the site are simple and clear.
The site content is written in a clear, orderly and hierarchical manner.
The site is adapted for viewing in modern browsers.
The site is adapted for display compatible with various screens and resolutions.
All pages on the site have a fixed structure (1H/2H/3H etc.).
All images on the site have alternative textual explanations (alt).
Accessibility software functionality:
Screen reader adaptation - Adapting the site for assistive technologies such as NVDA, JAWS
Stopping flashes
Direct skip to content
Keyboard navigation adaptation
Enlarging / reducing text
Spacing between letters / words / lines
Contrast and color
Readable font
Highlighting links
Reading guide
Changing cursor icon
Image description
Exceptions
It is important to note that despite our efforts to make all pages and elements on the site accessible, there may be parts or capabilities that have not been properly accessible or have not yet been made accessible.

We are constantly working to improve the accessibility of our site, as part of our commitment to enable the entire population to use it, including people with disabilities.`,
    accessibility_paragraph_5:
      'If you encounter an accessibility issue on the site, we would be happy to receive comments and requests by contacting our accessibility coordinator by email:',
    accessibility_paragraph_6:
      'Psifas will do its best to make the site accessible in the best possible way and respond to inquiries in the most professional and quick manner.',
    accessibility_paragraph_7: `The accessibility of this site was carried out by the website accessibility company "Vee Website Accessibility".
It adheres to the requirements of the Equal Rights for Persons with Disabilities Regulations 5568 of 2013 at AA level. And also implements the recommendations of the WCAG2.2 document from the W3C organization.`,
    accessibility_hebrew_label: 'In Hebrew: ',
    accessibility_hebrew_link_text: 'Guidelines for Internet Content Accessibility',
    accessibility_english_label: 'In English: ',
    accessibility_english_link_text: 'Web Content Accessibility Guidelines (WCAG) 2.0',
    form_thank_you_title: 'Thank you for your response',
    form_thank_you_subtitle: 'Your answers were received successfully',
    demo_watermark_text: 'Demo Questionnaire',
    demo_banner_text: 'Demo questionnaire – your answers are not saved',
    page_label: 'Page',
    of_label: 'of',
    pagination_prev_label: 'Previous',
    pagination_next_label: 'Next',
    submit_label: 'Submit',
    demo_thank_you_title: 'Thank you for participating in the demo questionnaire',
    close_label: 'Close',
    preview_modal_title: 'Please review your answers before submitting',
    finish_label: 'Finish',
    path_error_title: 'Path error',
    path_error_message:
      'An error occurred while loading the link.\nPlease verify the link is valid and try again.',
    preview_expired_message: 'The preview for this questionnaire has expired',
    validation_must_answer: 'Please answer this question',
    validation_date_invalid: 'Invalid date',
    validation_select_min_options: 'Please select at least %min% options',
    validation_number_between: 'Please enter a value between %min% and %max%',
    validation_number_min: 'The value must be at least %min%',
    validation_number_max: 'The value must be at most %max%',
    validation_invalid_number: 'Please enter a valid number',
    validation_invalid_input: 'Invalid input',
    validation_date_from_today: 'Please select a date from today onward',
    validation_date_no_future: 'Future dates are not allowed',
    validation_date_before_dep:
      'The date cannot be earlier than the date in question "%depLabel%" (%depValue%)',
    validation_date_after_or_equal_dep:
      'The date cannot be on or after the date in question "%depLabel%" (%depValue%)',
    validation_date_after_dep:
      'The date cannot be later than the date in question "%depLabel%" (%depValue%)',
    validation_number_before_dep:
      'The value cannot be less than the value in question "%depLabel%" (%depValue%)',
    validation_number_after_or_equal_dep:
      'The value cannot be greater than or equal to the value in question "%depLabel%" (%depValue%)',
    validation_number_after_dep:
      'The value cannot be greater than the value in question "%depLabel%" (%depValue%)',
    validation_error_question: 'Validation error in this question',
    validation_general_submit_error: 'Error submitting the form. Please try again.',
    validation_volunteer_name_mismatch:
      'The name does not match "%name%" at the top of the questionnaire',
    select_placeholder: 'Select',
  },
  [Languages.HEBREW]: {
    login_title: 'מיזם “פסיפס”',
    login_subtitle: 'כניסה לאיזור האישי',
    invalid_phone_number_or_email_error_message: 'יש להזין מספר טלפון/מייל תקין',
    login_description: 'לקבלת קוד אימות יש להזין את אמצעי הזיהוי אותו מסרת בעת ההתנדבות ל”פסיפס”',
    login_email_phone_placeholder: 'נייד או כתובת מייל',
    login_get_code_button_text: 'קבל קוד אימות',
    footer_paragraph: 'לכל תקלה טכנית בפתיחת הקישור או בהתחברות לשאלון, ניתן לפנות למספר:',
    exit_text: 'לדף הראשי',
    general_sever_error: 'שגיאה כללית. נסה שנית מאוחר יותר.',
    unauthorized_sf_error: 'אחד הפרטים שהזנת שגוי. אנא בדוק את המידע שהוזן שוב.',
    to_status_page_text: 'כניסה',
    check_input_modal_text:
      'בשל ריבוי ניסיונות, חשבונך נחסם זמנית. אנא נסה שוב מאוחר יותר או פנה במייל לכתובת',
    modal_exit_text: 'חזרה לדף הראשי',
    verification_description: 'קוד נשלח אל',
    enter_code_placeholder: 'הזנת קוד האימות',
    code_not_received: 'לא קיבלתי את הקוד. ',
    send_code_again: 'שלחו לי שוב',
    wait_for_code: 'הקוד בדרך...',
    invalid_code_message: 'הקוד לא תקין',
    form_does_not_exist_error: 'הטופס מולא והוגש, לא ניתן לגשת שנית',
    accessibility_statement_subtitle: 'תנאי שימוש',
    accessibility_text_1: 'תאריך עדכון הצהרת נגישות 29.05.2024',
    accessibility_subheader_1: 'כיצד עוברים למצב נגיש?',
    accessibility_subheader_2: 'תיקונים והתאמות שבוצעו באתר:',
    accessibility_subheader_3: 'יצירת קשר בנושא נגישות:',
    accessibility_subheader_4: 'המנגיש:',
    accessibility_paragraph_1: `פסיפס, אחראית על הקמת והפעלת אתר: https://psifas.org.il.
אנו רואים חשיבות רבה במתן שירות שוויוני לכלל האזרחים ובשיפור השירות הניתן לאזרחים עם מוגבלות.
אנו משקיעים משאבים רבים בהנגשת האתר והנכסים הדיגיטליים שלנו על מנת להפוך את שירותי החברה לזמינים יותר עבור אנשים עם מוגבלות.`,
    accessibility_paragraph_2: 'הנגשת האתר מתבצעת בהתאם לתקן הישראלי לנגישות 5568 לרמה AA.',
    accessibility_paragraph_3: `באתר מוצב אייקון נגישות (בד"כ בדפנות האתר). לחיצה על האייקון מאפשרת פתיחת של תפריט הנגישות. לאחר בחירת הפונקציה המתאימה בתפריט יש להמתין לטעינת הדף ולשינוי הרצוי בתצוגה (במידת הצורך).
במידה ומעוניינים לבטל את הפעולה, יש ללחוץ על הפונקציה בתפריט פעם שניה. בכל מצב, ניתן לאפס הגדרות נגישות
האתר מספק מבנה סמנטי עבור טכנולוגיות מסייעות ותמיכה בדפוס השימוש המקובל להפעלה עם מקלדת בעזרת מקשי החיצים, Enter ו- Esc ליציאה מתפריטים וחלונות.`,
    accessibility_paragraph_4: `האתר נבדק בקורא מסך מסוג NVDA והינו מותאם לגלישה בדפדפנים הנפוצים.
אמצעי הניווט באתר פשוטים וברורים.
תכני האתר כתובים באופן ברור, מסודר והיררכי.
האתר מותאם לצפייה בדפדפנים מודרניים.
התאמת האתר לתצוגה תואמת מגוון מסכים ורזולוציות.
כל הדפים באתר בעלי מבנה קבוע (1H/2H/3H וכו').
לכל התמונות באתר יש הסבר טקסטואלי חלופי (alt).
פונקציונליות תוכנת נגישות:
התאמה לקורא מסך - התאמת האתר עבור טכנולוגיות מסייעות כגון NVDA , JAWS
עצירת הבהובים
דילוג ישיר לתוכן
התאמה לניווט מקלדת
הגדלה / הקטנה של טקסט
ריווח בין אותיות / מילים / שורות
ניגודיות וצבע
גופן קריא
הדגשת קישורים
מדריך קריאה
שינוי אייקון סמן עכבר
תיאור לתמונות
החרגות
חשוב לציין, כי למרות מאמצינו להנגיש את כלל הדפים והאלמנטים באתר, ייתכן שיתגלו חלקים או יכולות שלא הונגשו כראוי או שטרם הונגשו.

אנו פועלים לשפר את נגישות האתר שלנו כל העת, כחלק ממחויבותנו לאפשר לכלל האוכלוסייה להשתמש בו, כולל אנשים עם מוגבלות.`,
    accessibility_paragraph_5: `במידה ונתקלתם בבעיה בנושא נגישות באתר, נשמח לקבל הערות ובקשות באמצעות פנייה לרכז הנגישות שלנו במייל:`,
    accessibility_paragraph_6: `פסיפס תעשה ככל יכולה על מנת להנגיש את האתר בצורה המיטבית ולענות לפניות בצורה המקצועית והמהירה ביותר.`,
    accessibility_paragraph_7: `הנגשת אתר זה בוצעה על ידי חברת הנגשת האתרים "Vee הנגשת אתרים".
מקפידה על עמידה בדרישות תקנות שוויון זכויות לאנשים עם מוגבלות 5568 התשע"ג 2013 ברמת AA. וכן, מיישמת את המלצות מסמך WCAG2.2 מאת ארגון W3C.`,
    accessibility_hebrew_label: `בעברית: `,
    accessibility_hebrew_link_text: `הנחיות לנגישות תכנים באינטרנט`,
    accessibility_english_label: ` באנגלית:`,
    accessibility_english_link_text: `Web Content Accessibility Guidelines (WCAG) 2.0`,
    form_thank_you_title: 'תודה על המענה',
    form_thank_you_subtitle: 'תשובותיך התקבלו בהצלחה',
    demo_watermark_text: 'שאלון דמה',
    demo_banner_text: 'שאלון דמה – תשובותיך אינן נשמרות',
    page_label: 'דף',
    of_label: 'מתוך',
    pagination_prev_label: 'הקודם',
    pagination_next_label: 'הבא',
    submit_label: 'שליחה',
    demo_thank_you_title: 'תודה על השתתפותך במילוי שאלון הדמה',
    close_label: 'סגור',
    preview_modal_title: 'אנא עבור על התשובות וודא שהן נכונות לפני שליחה',
    finish_label: 'סיום',
    path_error_title: 'שגיאה בנתיב',
    path_error_message: 'אירעה שגיאה בעת טעינת הקישור.\nאנא ודאו שהקישור תקין ונסו שוב.',
    preview_expired_message: 'תצוגה מקדימה לשאלון זה פגה',
    validation_must_answer: 'יש להשיב על השאלה',
    validation_date_invalid: 'תאריך לא תקין',
    validation_select_min_options: 'יש לבחור לפחות %min% אפשרויות',
    validation_number_between: 'יש להזין ערך בין %min% ל %max%',
    validation_number_min: 'הערך חייב להיות לפחות %min%',
    validation_number_max: 'הערך חייב להיות לכל היותר %max%',
    validation_invalid_number: 'נא להזין מספר חוקי',
    validation_invalid_input: 'קלט לא תקין',
    validation_date_from_today: 'יש לבחור תאריך מהיום ואילך',
    validation_date_no_future: 'לא ניתן לבחור תאריך עתידי',
    validation_date_before_dep:
      'לא ניתן להזין מועד מוקדם יותר מהמועד בשאלה "%depLabel%" (%depValue%)',
    validation_date_after_or_equal_dep:
      'לא ניתן להזין מועד מאוחר או שווה למועד בשאלה "%depLabel%" (%depValue%)',
    validation_date_after_dep:
      'לא ניתן להזין מועד מאוחר יותר מהמועד בשאלה "%depLabel%" (%depValue%)',
    validation_number_before_dep: 'לא ניתן להזין ערך קטן לערך בשאלה "%depLabel%" (%depValue%)',
    validation_number_after_or_equal_dep:
      'לא ניתן להזין ערך גדול או שווה לערך בשאלה "%depLabel%" (%depValue%)',
    validation_number_after_dep: 'לא ניתן להזין ערך גדול לערך בשאלה "%depLabel%" (%depValue%)',
    validation_error_question: 'שגיאת אימות בשאלה זו',
    validation_general_submit_error: 'שגיאה בהגשת הטופס. אנא נסה שוב.',
    validation_volunteer_name_mismatch: 'השם אינו תואם ל"%name%" המופיע בראש השאלון',
    select_placeholder: 'בחר',
  },
  [Languages.RUSSIAN]: {
    login_title: 'Проект Psifas',
    login_subtitle: 'Личный кабинет Вход',
    invalid_phone_number_or_email_error_message:
      'Введите действующий номер/адрес электронной почты',
    login_description:
      'Чтобы получить код подтверждения, введите метод идентификации, который Вы указали при волонтерстве для Psifas',
    login_email_phone_placeholder: 'Телефон или электронная почта',
    login_get_code_button_text: 'Получить код подтверждения',
    footer_paragraph:
      'По любым техническим проблемам с открытием ссылки или входом в анкету, вы можете обратиться по следующему номеру:',
    exit_text: 'Главная',
    general_sever_error: 'Общая ошибка. Повторите попытку позже.',
    unauthorized_sf_error:
      'Одна из введенных вами данных неверна. Проверьте введенную информацию еще раз.',
    to_status_page_text: 'Вход',
    check_input_modal_text:
      'Из-за нескольких попыток ваша учетная запись была временно заблокирована. Пожалуйста, повторите попытку позже или отправьте электронное письмо по адресу',
    modal_exit_text: 'Назад на главную страницу',
    verification_description: 'Код был отправлен ',
    enter_code_placeholder: 'Введите код',
    code_not_received: 'Я не получил код. ',
    send_code_again: 'Отправить снова',
    wait_for_code: 'Код уже в пути...',
    invalid_code_message: 'Неверный код',
    form_does_not_exist_error: 'Форма была заполнена и отправлена; повторный доступ невозможен.',
    accessibility_statement_subtitle: 'Условия использования',
    accessibility_text_1: 'Дата обновления заявления о доступности: 29.05.2024',
    accessibility_subheader_1: 'Как переключиться в режим доступности?',
    accessibility_subheader_2: 'Исправления и корректировки, внесенные на сайт:',
    accessibility_subheader_3: 'Контакт по вопросам доступности:',
    accessibility_subheader_4: 'Поставщик услуг доступности:',
    accessibility_paragraph_1: `Psifas несет ответственность за создание и эксплуатацию сайта: https://psifas.org.il.
Мы придаем большое значение предоставлению равных услуг всем гражданам и улучшению обслуживания граждан с ограниченными возможностями.
Мы вкладываем значительные ресурсы в обеспечение доступности нашего сайта и цифровых активов, чтобы сделать услуги компании более доступными для людей с ограниченными возможностями.`,
    accessibility_paragraph_2:
      'Доступность сайта обеспечивается в соответствии с израильским стандартом доступности 5568 до уровня AA.',
    accessibility_paragraph_3: `На сайте размещен значок доступности (обычно по бокам сайта). Нажатие на значок позволяет открыть меню доступности. После выбора соответствующей функции в меню дождитесь загрузки страницы и желаемого изменения в отображении (если необходимо).
Если вы хотите отменить действие, нажмите на функцию в меню второй раз. В любом случае, вы можете сбросить настройки доступности.
Сайт предоставляет семантическую структуру для вспомогательных технологий и поддержку традиционного шаблона использования для работы с клавиатурой с помощью клавиш со стрелками, Enter и Esc для выхода из меню и окон.`,
    accessibility_paragraph_4: `Сайт был протестирован с программой чтения с экрана NVDA и адаптирован для просмотра в общих браузерах.
Инструменты навигации на сайте просты и понятны.
Содержание сайта написано четким, упорядоченным и иерархическим образом.
Сайт адаптирован для просмотра в современных браузерах.
Сайт адаптирован для отображения, совместимого с различными экранами и разрешениями.
Все страницы на сайте имеют фиксированную структуру (1H/2H/3H и т.д.).
Все изображения на сайте имеют альтернативные текстовые пояснения (alt).
Функциональность программного обеспечения для доступности:
Адаптация для программ чтения с экрана - Адаптация сайта для вспомогательных технологий, таких как NVDA, JAWS
Остановка вспышек
Прямой переход к содержанию
Адаптация навигации с клавиатуры
Увеличение / уменьшение текста
Расстояние между буквами / словами / строками
Контраст и цвет
Читаемый шрифт
Выделение ссылок
Руководство по чтению
Изменение значка курсора
Описание изображения
Исключения
Важно отметить, что, несмотря на наши усилия сделать все страницы и элементы на сайте доступными, могут быть части или возможности, которые не были должным образом доступны или еще не были сделаны доступными.

Мы постоянно работаем над улучшением доступности нашего сайта в рамках нашего обязательства сделать его доступным для всего населения, включая людей с ограниченными возможностями.`,
    accessibility_paragraph_5:
      'Если вы столкнулись с проблемой доступности на сайте, мы будем рады получить комментарии и запросы, связавшись с нашим координатором по доступности по электронной почте:',
    accessibility_paragraph_6:
      'Psifas сделает все возможное, чтобы сделать сайт максимально доступным и ответить на запросы наиболее профессионально и быстро.',
    accessibility_paragraph_7: `Доступность этого сайта была обеспечена компанией по доступности веб-сайтов "Vee Website Accessibility".
Он соответствует требованиям Правил о равных правах для лиц с ограниченными возможностями 5568 от 2013 года на уровне AA. А также реализует рекомендации документа WCAG2.2 от организации W3C.`,
    accessibility_hebrew_label: 'На иврите: ',
    accessibility_hebrew_link_text: 'Руководство по доступности интернет-контента',
    accessibility_english_label: 'На английском: ',
    accessibility_english_link_text: 'Руководство по доступности веб-контента (WCAG) 2.0',
    form_thank_you_title: 'Спасибо за ваш ответ',
    form_thank_you_subtitle: 'Ваши ответы успешно получены',
    demo_watermark_text: 'Демо-опросник',
    demo_banner_text: 'Демо-опросник – ваши ответы не сохраняются',
    page_label: 'Страница',
    of_label: 'из',
    pagination_prev_label: 'Назад',
    pagination_next_label: 'Далее',
    submit_label: 'Отправить',
    demo_thank_you_title: 'Спасибо за участие в демо-опросе',
    close_label: 'Закрыть',
    preview_modal_title: 'Пожалуйста, проверьте ваши ответы перед отправкой',
    finish_label: 'Завершить',
    path_error_title: 'Ошибка пути',
    path_error_message:
      'Произошла ошибка при загрузке ссылки.\nПожалуйста, убедитесь, что ссылка действительна, и попробуйте снова.',
    preview_expired_message: 'Срок действия предварительного просмотра этого опросника истёк',
    validation_must_answer: 'Пожалуйста, ответьте на этот вопрос',
    validation_date_invalid: 'Неверная дата',
    validation_select_min_options: 'Выберите не менее %min% вариантов',
    validation_number_between: 'Введите значение от %min% до %max%',
    validation_number_min: 'Значение должно быть не менее %min%',
    validation_number_max: 'Значение должно быть не более %max%',
    validation_invalid_number: 'Введите корректное число',
    validation_invalid_input: 'Некорректный ввод',
    validation_date_from_today: 'Выберите дату начиная с сегодняшнего дня',
    validation_date_no_future: 'Будущие даты не допускаются',
    validation_date_before_dep:
      'Дата не может быть раньше даты в вопросе «%depLabel%» (%depValue%)',
    validation_date_after_or_equal_dep:
      'Дата не может быть позже или равна дате в вопросе «%depLabel%» (%depValue%)',
    validation_date_after_dep: 'Дата не может быть позже даты в вопросе «%depLabel%» (%depValue%)',
    validation_number_before_dep:
      'Значение не может быть меньше значения в вопросе «%depLabel%» (%depValue%)',
    validation_number_after_or_equal_dep:
      'Значение не может быть больше или равно значению в вопросе «%depLabel%» (%depValue%)',
    validation_number_after_dep:
      'Значение не может быть больше значения в вопросе «%depLabel%» (%depValue%)',
    validation_error_question: 'Ошибка проверки в этом вопросе',
    validation_general_submit_error: 'Ошибка отправки формы. Пожалуйста, попробуйте снова.',
    validation_volunteer_name_mismatch: 'Имя не совпадает с «%name%» в верхней части опросника',
    select_placeholder: 'Выберите',
  },
  [Languages.ARABIC]: {
    login_title: 'مشروع بسيفاس',
    login_subtitle: 'تسجيل الدخول إلى المنطقة الشخصية',
    invalid_phone_number_or_email_error_message: 'يرجى ادخال رقم هاتف/بريد الكتروني صحيح',
    login_description:
      'لتلقي رمز التحقق، يرجى إدخال طريقة التعريف التي قدمتها عند التطوع في بسيفاس',
    login_email_phone_placeholder: 'رقم الهاتف أو البريد الالكتروني',
    login_get_code_button_text: 'الحصول على رمز التحقق',
    footer_paragraph:
      'لأي مشكلة تقنية في فتح الرابط أو تسجيل الدخول إلى الاستبيان، يمكنكم التواصل على الرقم التالي:',
    exit_text: 'الرئيسية',
    general_sever_error: 'خطأ عام، يرجى المحاولة لاحقًا',
    unauthorized_sf_error:
      'أحد التفاصيل التي أدخلتها غير صحيحة. يرجى التحقق من المعلومات المدخلة مرة أخرى.',
    to_status_page_text: 'تسجيل الدخول',
    check_input_modal_text:
      'بسبب عدة محاولات، تم حظر حسابك مؤقتًا. يرجى المحاولة مرة أخرى في وقت لاحق أو إرسال العنوان بالبريد الإلكتروني',
    modal_exit_text: 'العودة للصفحة الرئيسية',
    verification_description: 'تم إرسال الرمز إلى ',
    enter_code_placeholder: 'قم بإدخال رمز التعريف',
    code_not_received: 'لم اتلقى أي رمز. ',
    send_code_again: 'يرجى الارسال مرة أخرى',
    wait_for_code: 'الكود في طريقه...',
    invalid_code_message: 'رمز غير صحيح',
    form_does_not_exist_error: 'تم تعبئة النموذج وتقديمه؛ لا يمكن الوصول إليه مرة أخرى.',
    accessibility_statement_subtitle: 'شروط الاستخدام',
    accessibility_text_1: 'تحديث بيان إمكانية الوصول: 29.05.2024',
    accessibility_subheader_1: 'كيف تتحول إلى وضع الوصول؟',
    accessibility_subheader_2: 'التصحيحات والتعديلات التي تم إجراؤها على الموقع:',
    accessibility_subheader_3: 'جهة الاتصال المتعلقة بإمكانية الوصول:',
    accessibility_subheader_4: 'مزود خدمات الوصول:',
    accessibility_paragraph_1: `تتحمل منظمة Psifas مسؤولية إنشاء وتشغيل الموقع: https://psifas.org.il. 
نرى أهمية كبيرة في تقديم خدمة متساوية لجميع المواطنين وتحسين الخدمة المقدمة للمواطنين ذوي الإعاقة.
نستثمر موارد كبيرة في جعل موقعنا وأصولنا الرقمية متاحة لجعل خدمات الشركة أكثر توفراً للأشخاص ذوي الإعاقة.`,
    accessibility_paragraph_2:
      'يتم تنفيذ إمكانية الوصول للموقع وفقًا للمعيار الإسرائيلي للنفاذية 5568 حتى مستوى AA.',
    accessibility_paragraph_3: `يوجد على الموقع أيقونة للنفاذية (عادةً على جوانب الموقع). يتيح النقر على الأيقونة فتح قائمة النفاذية. بعد اختيار الوظيفة المناسبة في القائمة، انتظر حتى يتم تحميل الصفحة وإجراء التغيير المطلوب في العرض (إذا لزم الأمر).
إذا كنت ترغب في إلغاء الإجراء، انقر على الوظيفة في القائمة مرة أخرى. في جميع الأحوال، يمكنك إعادة تعيين إعدادات النفاذية.
يوفر الموقع بنية دلالية للتقنيات المساعدة ودعمًا لنمط الاستخدام التقليدي لتشغيل لوحة المفاتيح باستخدام مفاتيح الأسهم، وEnter وEsc للخروج من القوائم والنوافذ.`,
    accessibility_paragraph_4: `تم اختبار الموقع باستخدام قارئ الشاشة NVDA وهو متوافق مع التصفح في المتصفحات الشائعة.
أدوات التنقل على الموقع بسيطة وواضحة.
تم كتابة محتوى الموقع بطريقة واضحة ومنظمة وهرمية.
الموقع متوافق مع العرض في المتصفحات الحديثة.
الموقع متوافق مع العرض المتناسب مع الشاشات والدقة المختلفة.
جميع الصفحات على الموقع لها هيكل ثابت (1H/2H/3H إلخ).
جميع الصور على الموقع تحتوي على تفسيرات نصية بديلة (alt).
وظائف برنامج النفاذية:
تكييف الموقع مع تقنيات المساعدة مثل NVDA، JAWS
إيقاف الوميض
تخطي مباشر للمحتوى
تكييف التنقل بلوحة المفاتيح
تكبير / تصغير النص
التباعد بين الحروف / الكلمات / الخطوط
التباين والألوان
خط قابل للقراءة
تمييز الروابط
دليل القراءة
تغيير أيقونة المؤشر
وصف الصورة
استثناءات
من المهم أن نلاحظ أنه على الرغم من جهودنا لجعل جميع الصفحات والعناصر على الموقع متاحة، قد تكون هناك أجزاء أو قدرات لم تكن متاحة بشكل صحيح أو لم يتم تفعيلها بعد.

نحن نعمل باستمرار على تحسين إمكانية الوصول إلى موقعنا، كجزء من التزامنا بتمكين جميع السكان من استخدامه، بما في ذلك الأشخاص ذوي الإعاقة.`,
    accessibility_paragraph_5:
      'إذا واجهت مشكلة في إمكانية الوصول على الموقع، يسعدنا تلقي تعليقات وطلبات من خلال التواصل مع منسق النفاذية لدينا عبر البريد الإلكتروني:',
    accessibility_paragraph_6:
      'ستبذل Psifas قصارى جهدها لجعل الموقع متاحًا بأفضل طريقة ممكنة والرد على الاستفسارات بأكثر الطرق احترافية وسرعة.',
    accessibility_paragraph_7: `تم تنفيذ إمكانية الوصول لهذا الموقع من قبل شركة "Vee Website Accessibility" للنفاذية.
تلتزم بمتطلبات لائحة حقوق الأشخاص ذوي الإعاقة 5568 لعام 2013 في مستوى AA. كما تنفذ توصيات وثيقة WCAG2.2 من منظمة W3C.`,
    accessibility_hebrew_label: 'بالعبرية: ',
    accessibility_hebrew_link_text: 'إرشادات إمكانية الوصول إلى محتوى الإنترنت',
    accessibility_english_label: 'بالإنجليزية: ',
    accessibility_english_link_text: 'إرشادات الوصول إلى محتوى الويب (WCAG) 2.0',
    form_thank_you_title: 'شكراً على ردك',
    form_thank_you_subtitle: 'تم استلام إجاباتك بنجاح',
    demo_watermark_text: 'استبيان تجريبي',
    demo_banner_text: 'استبيان تجريبي – إجاباتك لن يتم حفظها',
    page_label: 'صفحة',
    of_label: 'من',
    pagination_prev_label: 'السابق',
    pagination_next_label: 'التالي',
    submit_label: 'إرسال',
    demo_thank_you_title: 'شكراً لمشاركتك في ملء الاستبيان التجريبي',
    close_label: 'إغلاق',
    preview_modal_title: 'يرجى مراجعة إجاباتك قبل الإرسال',
    finish_label: 'إنهاء',
    path_error_title: 'خطأ في المسار',
    path_error_message:
      'حدث خطأ أثناء تحميل الرابط.\nيرجى التأكد من صحة الرابط والمحاولة مرة أخرى.',
    preview_expired_message: 'انتهت صلاحية المعاينة لهذا الاستبيان',
    validation_must_answer: 'يرجى الإجابة على هذا السؤال',
    validation_date_invalid: 'تاريخ غير صالح',
    validation_select_min_options: 'يرجى اختيار %min% خيارات على الأقل',
    validation_number_between: 'يرجى إدخال قيمة بين %min% و %max%',
    validation_number_min: 'يجب أن تكون القيمة %min% على الأقل',
    validation_number_max: 'يجب أن تكون القيمة %max% على الأكثر',
    validation_invalid_number: 'يرجى إدخال رقم صالح',
    validation_invalid_input: 'إدخال غير صالح',
    validation_date_from_today: 'يرجى اختيار تاريخ من اليوم فصاعدًا',
    validation_date_no_future: 'التواريخ المستقبلية غير مسموحة',
    validation_date_before_dep:
      'لا يمكن أن يكون التاريخ أبكر من التاريخ في السؤال "%depLabel%" (%depValue%)',
    validation_date_after_or_equal_dep:
      'لا يمكن أن يكون التاريخ في أو بعد التاريخ في السؤال "%depLabel%" (%depValue%)',
    validation_date_after_dep:
      'لا يمكن أن يكون التاريخ متأخرًا عن التاريخ في السؤال "%depLabel%" (%depValue%)',
    validation_number_before_dep:
      'لا يمكن أن تكون القيمة أقل من القيمة في السؤال "%depLabel%" (%depValue%)',
    validation_number_after_or_equal_dep:
      'لا يمكن أن تكون القيمة أكبر من أو تساوي القيمة في السؤال "%depLabel%" (%depValue%)',
    validation_number_after_dep:
      'لا يمكن أن تكون القيمة أكبر من القيمة في السؤال "%depLabel%" (%depValue%)',
    validation_error_question: 'خطأ في التحقق من هذا السؤال',
    validation_general_submit_error: 'خطأ في إرسال النموذج. يرجى المحاولة مرة أخرى.',
    validation_volunteer_name_mismatch: 'الاسم لا يطابق «%name%» الظاهر أعلى الاستبيان',
    select_placeholder: 'اختر',
  },
};

export function getTranslation(language: Languages) {
  return translations[language] || translations[Languages.HEBREW];
}
